import { mpx } from '@didi/es-mpx-creator'
import {
  USER_DETAIL_TOC,
  TRAIN_ID_TYPE_LIST,
  GROUP_COUNTRY,
  USER_CONTACTS_TOC
} from '../../api/urls'

// 获取加解密key
export const getSecretKey = () => {
  const params = {};
  return mpx.$http.get('/esapp/zeus/iapi_km/member/Contact/getSecretKey', { params, silent: true })
}

// 常用出行人列表
export const fetchContactList = (params) => {
  return mpx.$http.get('/esapp/zeus/iapi_km/member/Contact/getList', { params, silent: true })
}

// 选择出行人列表
export const fetchContactListV2 = (params) => {
  return mpx.$http.get('/esapp/zeus/iapi_km/member/Contact/getListV2', { params, silent: true, showLoading: false })
}

// 获取证件信息
export const fetchCardTypeList = ({ category, need_card }) => {
  const params = {
    category,
    need_card
  }
  return mpx.$http.get(TRAIN_ID_TYPE_LIST, { params, silent: true })
}

// 常用页面新增出行人
export const addContact = data => {
  return mpx.$http.post('/esapp/zeus/iapi_km/member/Contact/add', { data, silent: true })
}

// 选择页面新增出行人
export const addTraveler = data => {
  return mpx.$http.post('/esapp/zeus/iapi_km/member/Traveler/add', { data, silent: true })
}

// 常用页面编辑出行人
export const editContact = data => {
  return mpx.$http.post('/esapp/zeus/iapi_km/member/Contact/edit', { data, silent: true })
}

// 选择页面编辑出行人
export const editTraveler = data => {
  return mpx.$http.post('/esapp/zeus/iapi_km/member/Traveler/edit', { data, silent: true })
}

// 删除出行人
export const deleteContact = data => {
  return mpx.$http.post('/esapp/zeus/iapi_km/member/Contact/del', { data, silent: true })
}

// 出行人详情
export const fetchContactDetail = params => {
  return mpx.$http.get('/esapp/zeus/iapi_km/member/Contact/detail', { params, silent: true, showLoading: false })
}


// 个人因公是否有新增出行人权限
export const checkPermission = params => {
  return mpx.$http.get('/esapp/zeus/iapi_km/booking/checkPermission/index', { params, silent: true, showLoading: false })
}

// 根据差旅单查人
export const getListByTA = params => {
  return mpx.$http.get('/esapp/zeus/iapi_km/member/Contact/getListByTA', { params, silent: true, showLoading: false })
}

/**
 * @description 出行人列表
 * @wiki http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=585171517
 * @param {object} params - 请求参数
 * @property {string} params.category  - 品类 flight hotel train
 * @property {number} params.need_card - 是否需要证件信息 1是 0否
 * @property {number} params.scene - 场景 1因公 2因私
 * @property {string} params.keyword - 搜索关键词
 * @property {number} params.page_no - 分页页数，默认1
 * @property {number} params.page_size - 分页个数，默认10
 * @returns {promise}
 */
export const searchTraveler = (params) => {
  return mpx.$http.get('/esapp/zeus/iapi_km/member/Traveler/search', { params, silent: true })
}

// 批量获取出行人
export const getSelectedContact = data => {
  return mpx.$http.post('/esapp/zeus/iapi_km/member/Contact/mgetContacts', { data, silent: true, showLoading: false })
}

//请求国家分组列表
export const getGroupCountry = data => {
  const params = data || {}
  return mpx.$http.get(GROUP_COUNTRY, { params, silent: true })
}

//请求国家列表
export const getCountry = data => {
  const params = data || {}
  return mpx.$http.get('/esapp/demeter-ares/api/base/getCountry', { params, silent: true })
}

// toc新接口
// 获取12306出行人详情
export const fetch12306ContactDetail = params => {
  return mpx.$http.post(USER_DETAIL_TOC, { params, silent: true, showLoading: false })
}

// 请求乘车人列表
export const getTravelerList = data => {
  return mpx.$http.post(USER_CONTACTS_TOC, { data })
}